<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-12 col-12">
                <div class="form-group">
                    <label for="year">Year</label>
                    <input type="number" id="year" class="form-control" [(ngModel)]="target.year" name="year" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="planPercent">Plan Percent</label>
                    <input type="number" id="planPercent" class="form-control" [(ngModel)]="target.planPercent" name="planPercent" />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="bonusPoolPercent">Bonus Pool Percent</label>
                    <input
                        type="number"
                        id="bonusPoolPercent"
                        class="form-control"
                        [(ngModel)]="target.bonusPoolPercent"
                        name="bonusPoolPercent"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="overhead">Overhead</label>
                    <input type="number" id="overhead" class="form-control" [(ngModel)]="target.overhead" name="overhead" />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="plan">Plan</label>
                    <input type="number" id="plan" class="form-control" [(ngModel)]="target.plan" name="plan" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="extra">Extra</label>
                    <input type="number" id="extra" class="form-control" [(ngModel)]="target.extra" name="extra" />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="otherIncome">Other Income</label>
                    <input type="number" id="otherIncome" class="form-control" [(ngModel)]="target.otherIncome" name="otherIncome" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
